// extracted by mini-css-extract-plugin
export var card = "_76-1";
export var container = "_76-0";